import { useEffect, useState } from 'react';
import { db } from '../../../utils/firebase-config';
import { doc, getDoc, updateDoc } from "firebase/firestore";

const useUserProgress = (userId) => {
  const [progress, setProgress] = useState({});

  useEffect(() => {
    const fetchProgress = async () => {
      const docRef = doc(db, "users", userId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setProgress(data.progress || {});
      }
    };

    if (userId) {
      fetchProgress();
    }
  }, [userId]);

  return [progress, setProgress];
};

export default useUserProgress;
